/*eslint array-callback-return: ["off"]*/

import React from 'react';

import moment from 'moment';

import { Row, Col, Popover, Tooltip, Tag } from 'antd';

export default (translationsStore, commonStore) => ({
  width: '90px',
  align: 'center',
  title: translationsStore.translate('lead.table.column.dtcs'),
  dataIndex: 'dtc',
  className: 'dtcs',
  render: (text, record) => {
    if (record.dtcs.length === 0) {
      return <span>&mdash;</span>;
    }
    return (
      <Row>
        {record.dtcs.map((dtc, index) => {
          const dtcDescription = (dtc.dtcTranslations.find(translation => translation.language === translationsStore.locale) || {}).description || dtc.description;
          if (index === 1) {
            return (
              <Col key={index} id={`dtcs_${index}`}>
                <Popover
                  overlayStyle={{ width: '500px' }}
                  getPopupContainer={() => document.getElementById(`dtcs_${index}`)}
                  trigger="click"
                  content={
                    <div>
                      <Row style={{ border: '1px solid #ddd', background: '#eee', color: 'black' }}>
                        <Col span={4}>{translationsStore.translate('common.dtcCode')}</Col>
                        <Col span={12}>{translationsStore.translate('common.description')}</Col>
                        <Col span={4}>{translationsStore.translate('common.km')}</Col>
                        <Col span={4}>{translationsStore.translate('common.date')}</Col>
                      </Row>
                      {record.dtcs.map((dtc, index) => {
                        if (index > 0) {
                          const dtcDescription = (dtc.dtcTranslations.find(translation => translation.language === translationsStore.locale) || {}).description || dtc.description;
                          return (
                            <Row type="flex" key={index} style={{ borderBottom: '1px solid #bbbbbb' }}>
                              <Col span={3}>
                                <div style={{ color: dtc.severity }}>{dtc.code}</div>
                              </Col>
                              <Col span={13}>
                                <div style={{ color: dtc.severity }}>{dtcDescription}</div>
                              </Col>
                              <Col span={3}>
                                <div style={{ color: dtc.severity }}>{dtc.km}</div>
                              </Col>
                              <Col span={5}>
                                <div style={{ color: dtc.severity }}>{moment(dtc.createdAt).format(commonStore.longDateFormat.L)}</div>
                              </Col>
                            </Row>
                          );
                        }
                      })}
                    </div>
                  }
                >
                  <Tag>{'+' + (record.dtcs.length - 1)}</Tag>
                </Popover>
              </Col>
            );
          }
          if (index < 1) {
            return (
              <Col key={index}>
                <Tooltip title={dtcDescription} placement="right">
                  <span style={{ color: dtc.severity }}>{dtc.code}</span>
                </Tooltip>
              </Col>
            );
          }
        })}
      </Row>
    );
  }
});
